const types = [
  {value:1,label:"Transfer In"},
  {value:2,label:"Pembelian"},
]
const statuses = [
  {value:"",label:"Semua Status"},
  {value:"Disetujui Pusat",label:"Disetujui Pusat"},
  {value:"Pembelian",label:"Pembelian"},
]
const detailDefault = {
  id_items: null,
  item_name: "",
  qty: 1,
  id_unit: null,
  name_unit: "",
  note: ""
}

export default {
  types,
  statuses,
  detailDefault
}